import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cbc22a83"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nge-arv-title" }
const _hoisted_2 = { class: "nge-arv-pos" }
const _hoisted_3 = { class: "nge-arv-how" }
const _hoisted_4 = {
  key: 0,
  class: "nge-arv-quote"
}
const _hoisted_5 = {
  key: 1,
  class: "nge-arv-all"
}
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 2,
  ref: "ptsEl",
  class: "nge-arv-pts"
}
const _hoisted_9 = ["data-key"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-arv-dot" }, null, -1 /* HOISTED */))
const _hoisted_12 = ["disabled", "onClick"]
const _hoisted_13 = ["disabled", "onClick"]
const _hoisted_14 = {
  key: 3,
  class: "nge-arv-how"
}
const _hoisted_15 = { class: "nge-arv-verdict" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["disabled"]
const _hoisted_18 = ["disabled"]
const _hoisted_19 = {
  key: 5,
  class: "nge-arv-err",
  role: "alert"
}
const _hoisted_20 = {
  key: 6,
  class: "nge-arv-saved",
  role: "status"
}
const _hoisted_21 = {
  key: 7,
  class: "nge-arv-how nge-arv-locked"
}
const _hoisted_22 = { class: "nge-arv-nav" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($setup.request && $setup.item)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref: "boxEl",
        class: _normalizeClass(["nge-arv", { 'nge-arv--dragging': $setup.dragging }]),
        style: _normalizeStyle($setup.boxStyle),
        role: "dialog",
        "aria-label": "Review an access request"
      }, [
        _createElementVNode("div", {
          class: "nge-arv-head",
          title: "Drag to move",
          onPointerdown: _cache[2] || (_cache[2] = (...args) => ($setup.startDrag && $setup.startDrag(...args)))
        }, [
          _createElementVNode("span", _hoisted_1, _toDisplayString($setup.request.player_name || $setup.request.email), 1 /* TEXT */),
          _createElementVNode("span", _hoisted_2, _toDisplayString($setup.item.kind === 'cut' ? 'Cut' : 'Merge') + " " + _toDisplayString($setup.item.slot) + " · " + _toDisplayString($setup.index + 1) + " of " + _toDisplayString($setup.items.length), 1 /* TEXT */),
          _createElementVNode("button", {
            class: "nge-arv-x",
            title: "Stop reviewing: close this box and take the points away",
            "aria-label": "Stop reviewing",
            onPointerdown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
            onClick: _cache[1] || (_cache[1] = $event => {$setup.saveNote(); $setup.exitReview()})
          }, "×", 32 /* HYDRATE_EVENTS */)
        ], 32 /* HYDRATE_EVENTS */),
        _createElementVNode("p", _hoisted_3, _toDisplayString($setup.item.kind === 'cut' ? 'Two cells wrongly joined: red and blue points mark where the player would cut.' : 'One cell wrongly broken in two: each merge joins its point a to its point b.'), 1 /* TEXT */),
        ($setup.item.note)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Player: " + _toDisplayString($setup.item.note), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        ($setup.points.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("span", null, "All " + _toDisplayString($setup.points.length) + " points", 1 /* TEXT */),
              _createElementVNode("button", {
                class: _normalizeClass(["nge-arv-mark", { 'nge-arv-mark--good': $setup.allMarked('good') }]),
                disabled: $setup.busy || !$setup.canMark,
                onClick: _cache[3] || (_cache[3] = $event => ($setup.markAll('good')))
              }, "all good", 10 /* CLASS, PROPS */, _hoisted_6),
              _createElementVNode("button", {
                class: _normalizeClass(["nge-arv-mark", { 'nge-arv-mark--off': $setup.allMarked('off') }]),
                disabled: $setup.busy || !$setup.canMark,
                onClick: _cache[4] || (_cache[4] = $event => ($setup.markAll('off')))
              }, "all off", 10 /* CLASS, PROPS */, _hoisted_7)
            ]))
          : _createCommentVNode("v-if", true),
        ($setup.points.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.points, (p) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: p.key,
                  class: _normalizeClass(["nge-arv-pt", { 'nge-arv-pt--picked': $setup.pickedReviewPoint === p.key }]),
                  "data-key": p.key
                }, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["nge-arv-fly", `nge-arv-fly--${p.color}`]),
                    title: "Fly to this point",
                    onClick: $event => ($setup.flyToPoint(p.position))
                  }, [
                    _hoisted_11,
                    _createTextVNode(_toDisplayString(p.n), 1 /* TEXT */)
                  ], 10 /* CLASS, PROPS */, _hoisted_10),
                  _createElementVNode("button", {
                    class: _normalizeClass(["nge-arv-mark", { 'nge-arv-mark--good': $setup.item.point_marks?.[p.key] === 'good' }]),
                    disabled: $setup.busy || !$setup.canMark,
                    onClick: $event => ($setup.markPoint(p.key, 'good'))
                  }, "good", 10 /* CLASS, PROPS */, _hoisted_12),
                  _createElementVNode("button", {
                    class: _normalizeClass(["nge-arv-mark", { 'nge-arv-mark--off': $setup.item.point_marks?.[p.key] === 'off' }]),
                    disabled: $setup.busy || !$setup.canMark,
                    onClick: $event => ($setup.markPoint(p.key, 'off'))
                  }, "off", 10 /* CLASS, PROPS */, _hoisted_13)
                ], 10 /* CLASS, PROPS */, _hoisted_9))
              }), 128 /* KEYED_FRAGMENT */))
            ], 512 /* NEED_PATCH */))
          : (_openBlock(), _createElementBlock("p", _hoisted_14, "No points were saved with this example.")),
        ($setup.item.position)
          ? (_openBlock(), _createElementBlock("button", {
              key: 4,
              class: "nge-arv-link",
              onClick: _cache[5] || (_cache[5] = $event => ($setup.flyTo($setup.item.position)))
            }, "Back to where the player was looking"))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("button", {
            class: _normalizeClass(["nge-arv-v", { 'nge-arv-v--good': $setup.item.verdict === 'good' }]),
            disabled: $setup.busy || !$setup.canMark,
            onClick: _cache[6] || (_cache[6] = $event => ($setup.setVerdict('good')))
          }, "Good", 10 /* CLASS, PROPS */, _hoisted_16),
          _createElementVNode("button", {
            class: _normalizeClass(["nge-arv-v", { 'nge-arv-v--redo': $setup.item.verdict === 'redo' }]),
            disabled: $setup.busy || !$setup.canMark,
            onClick: _cache[7] || (_cache[7] = $event => ($setup.setVerdict('redo')))
          }, "Redo", 10 /* CLASS, PROPS */, _hoisted_17)
        ]),
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => (($setup.feedback) = $event)),
          class: "nge-arv-note",
          rows: "2",
          maxlength: "2000",
          disabled: !$setup.canMark,
          placeholder: "A note on this example for the player",
          onBlur: $setup.saveNote
        }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_18), [
          [_vModelText, $setup.feedback]
        ]),
        ($setup.error)
          ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString($setup.error), 1 /* TEXT */))
          : ($setup.saved)
            ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString($setup.saved) + ". The player sees it when you send your answer.", 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
        (!$setup.canMark)
          ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString($setup.request.status === 'redo' ? `Waiting for ${$setup.request.player_name || 'the player'} to send it again. You can mark it once it is sent.` : 'This request is closed, so its marks stay as they are.'), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("button", {
            class: "nge-arv-btn",
            disabled: $setup.index === 0,
            onClick: _cache[9] || (_cache[9] = $event => ($setup.go(-1)))
          }, "Back", 8 /* PROPS */, _hoisted_23),
          _createElementVNode("button", {
            class: "nge-arv-btn",
            disabled: $setup.index >= $setup.items.length - 1,
            onClick: _cache[10] || (_cache[10] = $event => ($setup.go(1)))
          }, "Next", 8 /* PROPS */, _hoisted_24),
          _createElementVNode("button", {
            class: "nge-arv-btn nge-arv-btn--list",
            onClick: _cache[11] || (_cache[11] = $event => {$setup.saveNote(); $setup.backToRequests()})
          }, "To the request")
        ])
      ], 6 /* CLASS, STYLE */))
    : _createCommentVNode("v-if", true)
}